import React, { useState } from "react";
import { supabase } from "../../services/supabase";
import { siteConfig } from "../../config/siteConfig";

const UpdatePasswordPage = () => {
  const { brand } = siteConfig;
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  // Validaciones en tiempo real
  const isLengthValid = newPassword.length >= 8;
  const hasNumber = /\d/.test(newPassword);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
  const passwordsMatch = newPassword === confirmPassword && newPassword !== "";

  const handleUpdate = async (e) => {
    e.preventDefault();

    const {
      data: { session },
    } = await supabase.auth.getSession();
    console.log("Sesión actual:", session);

    if (!session) {
      setMessage({
        type: "error",
        text: "Sesión no válida o expirada. Por favor, solicita otro enlace.",
      });
      return;
    }

    if (!isLengthValid || !hasNumber || !hasSpecial) return;
    if (!passwordsMatch) {
      setMessage({ type: "error", text: "Las contraseñas no coinciden." });
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPassword });

    if (error) {
      setMessage({ type: "error", text: error.message });
    } else {
      setMessage({
        type: "success",
        text: "¡Contraseña actualizada con éxito!",
      });
      setTimeout(() => (window.location.href = "/"), 2000);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl max-w-md w-full border border-slate-200">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-2.5 rounded-xl shadow-lg shadow-blue-200/50">
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
              />
            </svg>
          </div>
          <div className="flex flex-col leading-none">
            <span className="text-2xl font-extrabold tracking-tight bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
              {brand.namePrefix}
              <span className="text-blue-600">{brand.nameSuffix}</span>
            </span>
            {brand.subBrand && (
              <span className="text-[12px] font-bold text-blue-600 mt-0.5 tracking-tighter">
                {brand.subBrand}
              </span>
            )}
          </div>
        </div>

        <h2 className="text-xl font-bold text-slate-800 mb-2">
          Restablecer contraseña
        </h2>
        <p className="text-slate-500 text-sm mb-6">
          Crea una contraseña robusta para proteger tu cuenta.
        </p>

        <form onSubmit={handleUpdate} className="space-y-4">
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Nueva contraseña"
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none"
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Confirmar contraseña"
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none"
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="text-xs font-bold text-blue-600"
          >
            {showPassword ? "Ocultar" : "Ver"} contraseñas
          </button>

          {/* Indicadores de seguridad */}
          <div className="text-[11px] space-y-1 text-slate-400">
            <p className={isLengthValid ? "text-green-600" : ""}>
              ✓ Mínimo 8 caracteres
            </p>
            <p className={hasNumber ? "text-green-600" : ""}>
              ✓ Contiene un número
            </p>
            <p className={hasSpecial ? "text-green-600" : ""}>
              ✓ Contiene un carácter especial
            </p>
            <p className={passwordsMatch ? "text-green-600" : ""}>
              ✓ Las contraseñas coinciden
            </p>
          </div>

          <button
            disabled={loading || !passwordsMatch}
            className="w-full py-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all disabled:bg-slate-300"
          >
            {loading ? "Actualizando..." : "Guardar nueva contraseña"}
          </button>
        </form>

        <a
          href="/"
          className="block mt-6 text-center text-slate-400 text-sm font-medium hover:text-blue-600 transition-colors"
        >
          ← Volver al inicio
        </a>

        {message.text && (
          <div
            className={`mt-4 p-3 rounded-lg text-sm font-bold text-center ${
              message.type === "error"
                ? "bg-red-50 text-red-600"
                : "bg-green-50 text-green-600"
            }`}
          >
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdatePasswordPage;
